import React, { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { useTranslation } from 'react-i18next';
import { isValidPhoneNumber, CountryCode } from 'libphonenumber-js';
import { useField } from 'formik';

interface PhoneNumberInputProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  country?: string;
}

const PhoneNumberInput = ({ name, value, onChange, country }: PhoneNumberInputProps) => {
  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });
  const [field, meta] = useField(name);
  const [isLocallyValid, setIsLocallyValid] = useState(true);

  const internalOnChange = (newValue: string) => {
    const defaultCountry = country?.toUpperCase() as CountryCode | undefined;
    const isValid = isValidPhoneNumber(newValue || '', defaultCountry);
    setIsLocallyValid(isValid);
    onChange(newValue);
  };

  const showError = meta.touched && (!isLocallyValid || Boolean(meta.error));

  const errorMessage = meta.error
    ? meta.error
    : isLocallyValid
    ? ''
    : t('fieldErrors.incomplete', { field: t('telephoneNumber') });

  return (
    <>
      <label htmlFor="phone-input" className="s-label">
        {t('telephoneNumber')}
      </label>
      <PhoneInput
        country={country?.toLocaleLowerCase()}
        value={value}
        onChange={internalOnChange}
        onBlur={field.onBlur}
        inputStyle={{
          width: '100%',
          height: '44px',
          borderRadius: '5px',
          border: showError ? '1px solid red' : '1px solid lightgrey',
          paddingLeft: '48px',
        }}
        buttonStyle={{
          borderTopLeftRadius: '5px',
          borderBottomLeftRadius: '5px',
          border: showError ? '1px solid red' : '1px solid lightgrey',
          borderRight: 'none',
        }}
        containerStyle={{
          width: '100%',
        }}
        inputProps={{
          name: field.name,
          required: true,
          autoFocus: false,
          id: 'phone-input',
        }}
      />
      {showError && (
        <div style={{ color: 'red', fontSize: '0.8em', marginTop: '4px' }}>
          {meta.error ? t(meta.error) : errorMessage}
        </div>
      )}
    </>
  );
};

export default PhoneNumberInput;
